import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router } from "react-router-dom";
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/es/integration/react';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';

import { IntlProvider, addLocaleData } from "react-intl";
import { Provider } from "react-redux";
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { Fab, Action } from 'react-tiny-fab';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import messages from "./localization";
import { configureStore } from './store/configureStore';
import en from 'react-intl/locale-data/en';
const language = navigator.language.split(/[-_]/)[0];
addLocaleData([...en]);
export const store = configureStore();
let persistor = persistStore(store);


ReactDOM.render(
  <IntlProvider locale={language} messages={messages[language]}>
    <Provider store={store}>
    <PersistGate persistor={persistor}>
      <Router>
        <App />     
      </Router>
      </PersistGate>
    </Provider>
  </IntlProvider>,
  document.getElementById("root")
);
serviceWorker.unregister();
